export default __webpack_public_path__ + "static/media/halfGallonJar2.46f0cd1f.png";